(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gn-journal"] && !Shopify.designMode) return;
  try {
    
(() => {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const index = root.querySelector('[data-gnj-index]');
    const panels = [...root.querySelectorAll('[data-gnj-panel]')];
    let lastTrigger;
    function show(id, focus) {
      const panel = panels.find(p => p.id === id);
      index.hidden = Boolean(panel);
      panels.forEach(p => { p.hidden = p !== panel; });
      if (focus) {
        if (panel) {
          panel.querySelector('.gnj-story-title').focus({preventScroll:true});
          root.scrollIntoView({block:'start',behavior:'instant'});
        } else {
          root.scrollIntoView({block:'start',behavior:'instant'});
          lastTrigger?.focus({preventScroll:true});
        }
      }
    }
    function selected() { return location.hash.slice(1); }
    root.addEventListener('click', event => {
      const link = event.target.closest('a');
      if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      let id = link.dataset.gnjOpen;
      if (link.hasAttribute('data-gnj-back')) {
        event.preventDefault();
        history.pushState(null,'',location.pathname + location.search);
        show('',true);
        return;
      }
      if (!id && link.closest('.gnj-related')) {
        const handle = new URL(link.href).pathname.split('/').pop();
        if (panels.some(p => p.id === handle)) id = handle;
      }
      if (!id) return;
      if (link.getAttribute('href')?.startsWith('/') && !link.closest('.gnj-related')) return;
      event.preventDefault();
      lastTrigger = root.querySelector('[data-gnj-open="' + id + '"]');
      history.pushState(null,'','#' + id);
      show(id,true);
    });
    window.addEventListener('popstate',() => show(selected(),true));
    window.addEventListener('hashchange',() => show(selected(),false));
    show(selected(),false);
  }
  document.querySelectorAll('[data-gnj]').forEach(setup);
  document.addEventListener('shopify:section:load',e => e.target.querySelectorAll('[data-gnj]').forEach(setup));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gnawnu-retail"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gnawnu-retail'))customElements.define('gnawnu-retail',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;
  this.map=this.querySelector('.gr-map');this.popup=this.querySelector('.gr-stores');this.geo=this.querySelector('.gr-geography');
  this.map.append(this.popup);this.classList.add('gr-ready');
  this.pins=[...this.querySelectorAll('.gr-pin')];
  this.points=this.pins.map(pin=>{const lat=Number(pin.dataset.lat)*Math.PI/180;return {pin,x:(Number(pin.dataset.lon)+180)/360,y:(1-Math.asinh(Math.tan(lat))/Math.PI)/2};});
  this.popup.querySelectorAll('.gr-store-button').forEach(button=>button.tabIndex=-1);
  this.querySelector('.gr-popup-close').addEventListener('click',()=>this.close());
  this.addEventListener('keydown',e=>{if(e.key==='Escape'&&!this.popup.hidden){this.close();e.preventDefault();}});
  this.querySelector('[data-store-picker]').addEventListener('change',e=>this.select(e.target.value));
  this.addEventListener('click',e=>{
   const pin=e.target.closest('.gr-pin');
   if(pin){this.select(pin.dataset.key);return;}
   const control=e.target.closest('[data-map-action]');
   if(control){
    const action=control.dataset.mapAction;
    if(action==='reset'){this.close(false);this.fit();return;}
    if(!this.popup.hidden){const point=this.points.find(p=>p.pin.dataset.key===this.selected);this.center={x:point.x,y:point.y};}
    this.zoom=Math.min(16,Math.max(this.fitZoom-1,this.zoom+(action==='in'?.5:-.5)));
    this.draw();return;
   }
   if(e.target.closest('.gr-map-frame'))this.close(false);
  });
  this.resizeObserver=new ResizeObserver(()=>{this.close(false);this.fit();});this.resizeObserver.observe(this.map);
  this.close(false);this.fit();
 }
 disconnectedCallback(){this.resizeObserver?.disconnect();this.ready=false;}
 close(restoreFocus=true){
  this.popup.hidden=true;
  this.querySelector('[data-store-picker]').value='';
  this.querySelectorAll('.gr-pin').forEach(pin=>{pin.setAttribute('aria-pressed','false');pin.setAttribute('aria-expanded','false');pin.dataset.selected='false';});
  if(restoreFocus)this.querySelector(`.gr-pin[data-key="${this.selected}"]`)?.focus({preventScroll:true});
 }
 select(key){
  if(!key)return;
  this.selected=key;this.popup.hidden=false;
  this.querySelectorAll('[data-store]').forEach(row=>{
   const selected=row.dataset.store===key;row.dataset.selected=String(selected);
   row.querySelector('button').setAttribute('aria-expanded',String(selected));
   row.querySelector('.gr-store-detail').hidden=!selected;
  });
  this.querySelectorAll('.gr-pin').forEach(pin=>{
   const selected=pin.dataset.key===key;pin.dataset.selected=String(selected);
   pin.setAttribute('aria-pressed',String(selected));pin.setAttribute('aria-expanded',String(selected));
   if(selected){this.querySelector('[data-map-status]').textContent=this.querySelector(`[data-store="${key}"]`).innerText;}
  });
  this.querySelector('[data-store-picker]').value=key;
  if(this.zoom>this.fitZoom+.1){const point=this.points.find(p=>p.pin.dataset.key===key);this.center={x:point.x,y:point.y};this.draw();}else this.position();
 }
 fit(){
  const xs=this.points.map(p=>p.x),ys=this.points.map(p=>p.y),x0=Math.min(...xs),x1=Math.max(...xs),y0=Math.min(...ys),y1=Math.max(...ys);
  this.center={x:(x0+x1)/2,y:(y0+y1)/2};
  this.fitZoom=Math.min(Math.log2((this.map.clientWidth-110)/(256*(x1-x0))),Math.log2((this.map.clientHeight-180)/(256*(y1-y0))));
  this.zoom=this.fitZoom;this.draw();
 }
 draw(){
  const width=this.map.clientWidth,height=this.map.clientHeight;if(!width||!height)return;
  const svg=this.querySelector('.gr-map-svg'),tiles=this.querySelector('.gr-tiles'),size=256*Math.pow(2,this.zoom),z=Math.min(18,Math.ceil(this.zoom+Math.log2(Math.min(window.devicePixelRatio||1,2)))),tileSize=256*Math.pow(2,this.zoom-z),left=this.center.x*size-width/2,top=this.center.y*size-height/2;
  svg.setAttribute('viewBox',`0 0 ${width} ${height}`);svg.setAttribute('preserveAspectRatio','xMidYMid meet');
  const old=new Map([...tiles.children].map(el=>[el.dataset.tile,el])),keep=new Set();
  for(let x=Math.floor(left/tileSize);x<=Math.floor((left+width)/tileSize);x++)for(let y=Math.floor(top/tileSize);y<=Math.floor((top+height)/tileSize);y++){
   const key=`${z}/${x}/${y}`;keep.add(key);let tile=old.get(key);
   if(!tile){tile=document.createElementNS('http://www.w3.org/2000/svg','image');tile.dataset.tile=key;tile.setAttribute('href',`https://tile.openstreetmap.org/${key}.png`);tiles.append(tile);}
   tile.setAttribute('x',x*tileSize-left);tile.setAttribute('y',y*tileSize-top);tile.setAttribute('width',tileSize+.25);tile.setAttribute('height',tileSize+.25);
  }
  old.forEach((tile,key)=>{if(!keep.has(key))tile.remove();});
  const placed=this.points.map(p=>({pin:p.pin,ax:p.x*size-left,ay:p.y*size-top,x:p.x*size-left,y:p.y*size-top}));
  for(let pass=0;pass<18;pass++)for(let i=0;i<placed.length;i++)for(let j=i+1;j<placed.length;j++){
   const a=placed[i],b=placed[j],dx=b.x-a.x,dy=b.y-a.y,d=Math.hypot(dx,dy);
   if(d<46){const gap=(46-d)/2,ux=d?dx/d:1,uy=d?dy/d:0;a.x-=ux*gap;a.y-=uy*gap;b.x+=ux*gap;b.y+=uy*gap;}
  }
  let leaders=svg.querySelector('.gr-leaders');if(!leaders){leaders=document.createElementNS('http://www.w3.org/2000/svg','g');leaders.classList.add('gr-leaders');svg.append(leaders);}leaders.replaceChildren();
  placed.forEach(p=>{
   p.pin.style.setProperty('--pin-x',(p.x/width*100)+'%');p.pin.style.setProperty('--pin-y',(p.y/height*100)+'%');
   if(Math.hypot(p.x-p.ax,p.y-p.ay)>4){const line=document.createElementNS('http://www.w3.org/2000/svg','line');line.setAttribute('x1',p.ax);line.setAttribute('y1',p.ay);line.setAttribute('x2',p.x);line.setAttribute('y2',p.y);line.setAttribute('stroke','#1b2440');line.setAttribute('stroke-width','1');leaders.append(line);const dot=document.createElementNS('http://www.w3.org/2000/svg','circle');dot.setAttribute('cx',p.ax);dot.setAttribute('cy',p.ay);dot.setAttribute('r','2');dot.setAttribute('fill','#1b2440');leaders.append(dot);}
  });
  this.position();
 }
 position(){
  if(this.popup.hidden||!this.selected)return;
  const pin=this.querySelector(`.gr-pin[data-key="${this.selected}"]`),bounds=this.map.getBoundingClientRect(),p=pin.getBoundingClientRect();
  const x=p.left+p.width/2-bounds.left,y=p.top+p.height/2-bounds.top,w=this.popup.offsetWidth,h=this.popup.offsetHeight;
  const left=Math.max(14,Math.min(bounds.width-w-14,x-w/2));
  const preferred=y-h-27>70?y-h-27:y+27;
  const top=Math.max(70,Math.min(bounds.height-h-55,preferred));
  this.popup.style.left=left+'px';this.popup.style.top=top+'px';
 }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
